import axios from 'axios';
import { generateSignature, rsaEncryptWithPublicKey, rsaDecryptWithPublicKey, rsaDecryptWithPrivateKey } from '@/utils/sign_utils.js'
import { LocalStorageKeys } from '@/utils/local_storage';
import router from '@/router';

const baseURL = process.env.VUE_APP_BASE_URL;
const RSA = process.env.VUE_APP_RSA;
const VERSION = process.env.VUE_APP_VERSION;

// 创建 axios 实例
const request = axios.create({
  baseURL: baseURL, // 设置基础请求路径
  timeout: 60*1000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
request.interceptors.request.use(
  async (config) => {
    // 从 localStorage 或其他位置获取 token
    const userInfoEn = localStorage.getItem(LocalStorageKeys.USER_INFO);
    var token = ''
    if (userInfoEn != null) {
      const userInfoDe = await rsaDecryptWithPrivateKey(localStorage.getItem(LocalStorageKeys.USER_INFO));
      const userInfo = JSON.parse(userInfoDe);
      token = userInfo.token
    }

    const apiTime = Math.floor(Date.now() / 1000);
    const apiVersion = VERSION;
    const apiPlatform = 'web';
    // 获取请求的参数 (GET 请求使用 params，POST 请求使用 data)
    let requestData = config.method === 'get' ? config.params : config.data;

    // 如果 requestData 为 undefined 或 null，初始化为空对象
    if (!requestData) {
      requestData = {};
    }

    // 生成一个指定长度的随机字符串（比如 16）
    const randomString = generateRandomString(16);  // 生成一个 16 位长度的随机字符串
    // 将随机字符串加入到 requestData
    requestData.randomString = randomString;

    // 使用请求参数和 apiTime 生成签名
    const apiSign = generateSignature(requestData || {}, apiTime);

    if (RSA) {
      var rsaEnRes = await rsaEncryptWithPublicKey(JSON.stringify(requestData));
      config.data = rsaEnRes
    }

    // 设置自定义请求头
    config.headers['api-version'] = apiVersion;
    config.headers['api-token'] = token || '';
    config.headers['api-time'] = apiTime;
    config.headers['api-sign'] = apiSign;
    config.headers['api-platform'] = apiPlatform;
    config.headers['channel'] = 'web';

    return config;
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  async (response) => {
    const {
      data,
      status
    } = response;
    if (status === 200) {
      var resDeRes = data;
      if (RSA) {
        resDeRes = await rsaDecryptWithPublicKey(data);
      }
      if (resDeRes.code == 200) {
        return resDeRes;
      } else {
        if (resDeRes.code == 980) {
          localStorage.removeItem(LocalStorageKeys.USER_INFO);
          if (router.currentRoute.path !== '/login') {
            router.replace('/login');
          }
        }
        return Promise.reject(resDeRes.msg);
      }
    } else {
      return Promise.reject(resDeRes.msg);
    }
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          alert('Unauthorized. Please log in again.');
          break;
        case 404:
          alert('API not found');
          break;
        default:
          alert(`Error: ${error.response.status}`);
      }
    }
    return Promise.reject(error);
  }
);


export default request;

/**
 * 生成指定长度的随机字符串
 * @param {number} length - 随机字符串的长度
 * @returns {string} 随机生成的字符串
 */
function generateRandomString(length) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));  // 随机选择一个字符
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/api/request.js